<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" :src="avatar"> -->
        <i class="el-icon-caret-bottom"></i>
      </div>
     <div>
       <div class='user-info'>{{userInfo.name}}<div>{{userInfo.phone}}</div></div>
     </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <div @click="forgetPassword">修改密码</div>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <div @click="logout" style="display:block;">退出</div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改密码" :visible.sync="popup" width="50%">
      <el-form  status-icon  label-width="100px"  class="demo-ruleForm">
         <el-form-item label="账号" prop="phoneNumber" style="margin-left: 13%;" >
             <el-input v-model="thirdlyId" clearable placeholder="请输入手机号码" style="width: 50%; margin-left: 5%;"></el-input>
               <!-- <el-button type="primary" @click="getCode">获取验证码</el-button> -->
         </el-form-item>
         <el-form-item label="输入验证码"  style="margin-left: 13%;" >
             <el-input v-model="verificationCode" placeholder="请输入验证码" style="width: 30%; margin-left: 5%;"></el-input>
             <el-button  type="primary" icon="el-icon-mobile-phone" @click="send"   :disabled="disabled=!show" >
                 <span v-show="show">获取验证码</span>
                 <span v-show="!show" class="count">{{count}} s</span>
              </el-button>
         </el-form-item>
        <!-- <el-form-item label="验证码" prop="phoneNumber" style="margin-left: 13%;" >
             <el-input v-model="verificationCode"  style="width: 30%; margin-left: 5%;"></el-input>
         </el-form-item> -->
          <el-form-item label="密码" prop="passWord" style="margin-left: 13%;">
             <el-input type="password" v-model="passWord" autocomplete="off" style="width: 50%; margin-left: 5%;"></el-input>
           </el-form-item>
           <el-form-item label="确认密码" prop="checkPass" style="margin-left: 13%;">
             <el-input type="password" v-model="checkPass" autocomplete="off" style="width: 50%; margin-left: 5%;"></el-input>
           </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="popup = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { verificationCode, updatePassword,getUserInfo} from "@/api/login";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data(){
    return{
      thirdlyId:null,
      popup:false,
      verificationCode:null,
      passWord:null,
      checkPass:null,
      show: true,  // 初始启用按钮
      count: '',   // 初始化次数
      timer: null,
      // navbar顶部显示消息
      userInfo:{
        name:'',
        phone:'',
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取用户信息
    getInfo(){
      const obj = {};
      getUserInfo(obj).then(response => {
        if(response.code == 200){
          this.userInfo['name'] = response.data.pharmacistName;
          this.userInfo['phone'] = response.data.phoneNumber;
        }
      });
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    forgetPassword(){
      this.popup = true;
      this.thirdlyId = null;
      this.verificationCode = null;
      this.passWord = null;
      this.checkPass = null;
    },
    // getCode(){
    //   verificationCode(this.thirdlyId).then(res => {
    //       if(200 != res.code){
    //         this.$message.error(res.message);
    //       }
    //   });
    // },
    send(){
      if(this.thirdlyId === null){
        this.$message.error("请输入手机号码");
        return false;
      }else{
        verificationCode(this.thirdlyId).then(res => {
            if(200 != res.code){
              this.$message.error(res.message);
            }
        });
        var TIME_COUNT = 60;
              if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);  // 清除定时器
                      this.timer = null;
                    }
                  }, 1000)
                }
      }
          }   ,
    submitUpdate(){
      let par = {};
      par.newPassword = this.passWord;
      par.thirdlyId = this.thirdlyId;
      par.verificationCode = this.verificationCode;
       if(this.thirdlyId == null){
        this.$message.error("账号不能为空");
        return false;
      }
      if(this.verificationCode == null){
        this.$message.error("验证码不能为空");
        return false;
      }
      if(this.passWord == null){
        this.$message.error("密码不能为空");
        return false;
      }
      let rule = /((?=.*[0-9])(?=.*[a-z])|(?=.*[0-9])(?=.*[A-Z])).{8,17}$/;
      if (!rule.test(this.passWord)) {
         this.$message.error("请输入正确的密码:至少8～16位，由数字字母符号（非纯数字、非纯字母）组成");
         return
      }
      if(this.passWord != this.checkPass){
        this.$message.error("确认密码与密码不一致啊");
        return false;
      }
      updatePassword(par).then(response => {
        if(200 != response.code){
           if (response.code == 1018) {
            this.$message.error("请输入正确的密码:至少8～16位，由数字字母符号（非纯数字、非纯字母）组成");
            return
          }
          this.$message.error(res.message);
        } else {
          this.$message.error("操作成功");
          this.popup = false
        }
      });
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
    .user-info{
      font-size: 13px;
      line-height: 21px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue